var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21120_42386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21120_42386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3307C8.38824 18.3307 7.01324 17.7613 5.87435 16.6224C4.73546 15.4835 4.16602 14.1085 4.16602 12.4974V7.4974C4.16602 5.88628 4.73546 4.51128 5.87435 3.3724C7.01324 2.23351 8.38824 1.66406 9.99935 1.66406C11.6105 1.66406 12.9855 2.23351 14.1243 3.3724C15.2632 4.51128 15.8327 5.88628 15.8327 7.4974V12.4974C15.8327 14.1085 15.2632 15.4835 14.1243 16.6224C12.9855 17.7613 11.6105 18.3307 9.99935 18.3307ZM10.8327 7.4974H14.166C14.166 6.4974 13.85 5.61545 13.2181 4.85156C12.5862 4.08767 11.791 3.60851 10.8327 3.41406V7.4974ZM5.83268 7.4974H9.16602V3.41406C8.20768 3.60851 7.41254 4.08767 6.7806 4.85156C6.14865 5.61545 5.83268 6.4974 5.83268 7.4974ZM9.99935 16.6641C11.1521 16.6641 12.1348 16.2578 12.9473 15.4453C13.7598 14.6328 14.166 13.6502 14.166 12.4974V9.16406H5.83268V12.4974C5.83268 13.6502 6.23893 14.6328 7.05143 15.4453C7.86393 16.2578 8.84657 16.6641 9.99935 16.6641Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.83dc10e08a1774450d1f3cf85e4acee0.svg";
export { ForwardRef as ReactComponent };